import { render, staticRenderFns } from "./HelpdeskAssignee.vue?vue&type=template&id=b6d3e950&scoped=true&"
import script from "./HelpdeskAssignee.vue?vue&type=script&lang=ts&"
export * from "./HelpdeskAssignee.vue?vue&type=script&lang=ts&"
import style0 from "./HelpdeskAssignee.vue?vue&type=style&index=0&id=b6d3e950&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d3e950",
  null
  
)

export default component.exports